import { FC, HTMLAttributes } from 'react';
import RentVerificationRow from 'src/components/organisms/RentVerificationRow';
import { RentVerificationTableItem } from 'src/pages/FDEInboxPage/components/RentVerificationList';
import { RoleType } from 'src/ts/interfaces';

export interface RentVerificationTableProps extends HTMLAttributes<HTMLDivElement> {
  verifications: RentVerificationTableItem[];
  role: RoleType;
}

const RentVerificationTable: FC<RentVerificationTableProps> = ({ verifications, role }) => {
  return (
    <>
      {verifications.map((verification) => (
        <RentVerificationRow key={verification.id} verification={verification} role={role} />
      ))}
    </>
  );
};

export default RentVerificationTable;
